import { Col, Form, InputNumber, Select, Space } from 'antd';
import { addDays, isBefore, parseISO, startOfDay, isSameDay } from 'date-fns';
import styles from '../index.module.less';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAllUsers, updateTaskAssignment } from '../redux/slice';
import CustomModal from '@/common/CustomModal';

export default function TaskAssignModal({
  isOpen,
  setIsOpen,
  onAssign,
  taskData
}) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [team, setTeam] = useState([]);

  const handleClose = () => {
    setIsOpen(null);
    form.resetFields();
  };

  // useEffect(() => {
  //   dispatch(getAllUsers()).then((res) => {
  //     if (res?.payload.data) {
  //       setTeam(res?.payload?.data);
  //     }
  //   });
  // }, []);

  console.log('taskData', taskData);

  useEffect(() => {
    if (taskData) {
      form.setFieldsValue({
        hours:
          taskData.hours !== undefined && taskData.hours !== null
            ? Number(taskData.hours)
            : 0,
        user_id: taskData.assignee?.id ?? null
      });
    } else {
      form.resetFields();
    }
  }, [taskData]);

  const isUserOnLeaveOrStartingSoon = (user) => {
    // If leave ends today, user is available for tomorrow - allow them
    if (user.leave_end_date) {
      try {
        const leaveEndDay = startOfDay(parseISO(user.leave_end_date));
        const today = startOfDay(new Date());
        if (isSameDay(leaveEndDay, today)) {
          return false;
        }
      } catch {
        // ignore parse errors
      }
    }

    if (user.on_leave) return true;
    if (!user.leave_start_date) return false;
    const today = startOfDay(new Date());
    const tomorrow = addDays(today, 1);
    try {
      const leaveStartDay = startOfDay(parseISO(user.leave_start_date));
      return (
        isBefore(leaveStartDay, tomorrow) || isSameDay(leaveStartDay, tomorrow)
      );
    } catch {
      return false;
    }
  };

  useEffect(() => {
    if (!isOpen) return;

    dispatch(getAllUsers()).then((res) => {
      if (res?.payload?.data) {
        const filteredTeam = res.payload.data.filter(
          (user) =>
            !(
              (user.staff_augmentation === true &&
                (user.staff_augmentation_percentage ?? 0) >= 100) ||
              isUserOnLeaveOrStartingSoon(user)
            )
        );

        setTeam(filteredTeam);
      }
    });
  }, [isOpen]);

  const onFinish = (values) => {
    if (!taskData) return;

    const payload = {
      task_id: taskData.id,
      user_id: values.user_id,
      ...(values.hours !== undefined &&
      values.hours !== null &&
      values.hours !== ''
        ? { hours: values.hours }
        : {})
    };

    dispatch(updateTaskAssignment(payload)).then((res) => {
      if (res?.payload?.success) {
        form.resetFields();
        onAssign();
        setIsOpen(null);
      }
    });
  };

  return (
    <CustomModal
      visible={isOpen}
      footer={null}
      className={`!w-full sm:!w-[35%] md:!w-[30%] lg:!w-[25%] xl:!w-[20%] ${styles.customModal}`}
      closable={false}
      centered
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        // onValuesChange={handleFormValuesChange}
      >
        <h3 className={styles.mainTitle} style={{ fontWeight: 'bold' }}>
          Assign task
        </h3>

        <FormItem
          label="Select team member"
          name="user_id"
          rules={[{ required: true, message: 'Team member is required' }]}
          style={{ marginTop: '1rem' }}
        >
          <Select
            showSearch
            optionFilterProp="children"
            // defaultValue="Select team member"
            placeholder="Select team member"
            style={{ width: '100%' }}
            className={styles.selectField}
          >
            {team?.length
              ? team?.map((item, index) => {
                  return (
                    // <option value={item?.id} key={index}>
                    //   {item?.first_name} {item?.last_name}
                    // </option>
                    <Select.Option value={item?.id} key={item?.id}>
                      {item?.first_name} {item?.last_name}
                    </Select.Option>
                  );
                })
              : ''}
          </Select>
        </FormItem>
        <Col span={24} style={{ position: 'relative' }}>
          <FormItem
            label="Estimated hours"
            name="hours"
            className={styles.customLable}
            rules={[
              {
                validator: (_, value) => {
                  if (value === undefined || value === null) {
                    return Promise.resolve();
                  }

                  if (value > 10) {
                    return Promise.reject(
                      new Error('Estimated hours cannot exceed 10')
                    );
                  }

                  return Promise.resolve();
                }
              }
            ]}
          >
            {/* <InputNumber
              style={{ width: '100%' }}
              min={0}
              step={0.5}
              precision={2}
              placeholder="e.g. 3"
            /> */}
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              step={0.5}
              precision={2}
              placeholder="e.g. 3"
              controls={false}
              onKeyDown={(e) => {
                const allowedKeys = [
                  'Backspace',
                  'Delete',
                  'ArrowLeft',
                  'ArrowRight',
                  'Tab'
                ];

                if (allowedKeys.includes(e.key) || /^[0-9.]$/.test(e.key)) {
                  return;
                }

                e.preventDefault();
              }}
            />
          </FormItem>

          <div
            style={{
              position: 'absolute',
              right: 0,
              top: 0,
              paddingRight: '12px'
            }}
          ></div>
        </Col>

        <FormItem className="text-center">
          <Space style={{ marginTop: '20px' }}>
            <CustomButton
              className={styles.inwardButton}
              onClick={() => handleClose()}
              type="primary"
              ghost
            >
              Close
            </CustomButton>
            <CustomButton
              className={styles.inwardButton}
              htmlType="submit"
              type="primary"
            >
              Assign
            </CustomButton>
          </Space>
        </FormItem>
      </Form>
    </CustomModal>
  );
}
